import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay, FreeMode } from 'swiper/modules'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/free-mode'

const imageCarousels = document.querySelectorAll('.imageCarousel')

Array.from(imageCarousels).forEach((carouselEl) => {
    const swiperEl = carouselEl.querySelector('.imageCarousel__swiper')
    const prevButton = carouselEl.querySelector('.imageCarousel__button.-prev')
    const nextButton = carouselEl.querySelector('.imageCarousel__button.-next')
    const paginationEl = carouselEl.querySelector('.imageCarousel__pagination')

    if (!swiperEl) {
        return
    }

    const modules = [Navigation, Autoplay, FreeMode]
    const config = {
        slidesPerView: 3,
        spaceBetween: 30,
        loop: true,
        speed: 5000,
        freeMode: true,
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
    }

    // Only add pagination if the element exists
    if (paginationEl) {
        modules.push(Pagination)
        config.pagination = {
            el: paginationEl,
            clickable: true,
            bulletClass: 'imageCarousel__paginationBullet',
            bulletActiveClass: '-active',
            renderBullet: function (index, className) {
                return `<span class="${className}"></span>`
            },
        }
    }

    new Swiper(swiperEl, {
        modules: modules,
        ...config,
    })
})

